// eslint-disable-next-line no-use-before-define
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Paper } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { generateCompensationPeriods } from "../../utils/compensation/compensation";
import OriolaPeriodRow from "./oriolaPeriodRow";
import {
  Header,
  CompensationSearchControls,
  CompensationTitle,
} from "../common";
import {
  getInServiceProfitCenters,
  fetchProcessSteps,
} from "../../redux";

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    padding: "1rem",
  },
  actionContainer: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  error: {
    color: "red",
    ...theme.typography.body1,
  },
}));

// TODO: loading and error
function Oriola() {
  const classes = useStyles();
  useTranslation();
  const dispatch = useDispatch();
  const [currentYear, setCurrentYear] = useState(moment().year().toString());

  const {
    compensationsMap,
    filteredCompensationsMap,
    filteredCompensationCount,
    fetchError,
    fetchingMap,
    searching,
    searchError,
  } = useSelector(state => state.compensation);
  const [periods, setPeriods] = useState([]);
  const [periodCompensations, setPeriodCompensations] = useState([]);
  const inServiceProfitCenters = useSelector(
    state => state.profitCenters.inServiceProfitCenters
  );

  useEffect(() => {
    // set periods
    const currentYearPeriods =
      generateCompensationPeriods(currentYear).reverse();
    setPeriods(currentYearPeriods);

    // fetch process steps for each period in the year
    const periodStartDates = currentYearPeriods
      .map(period => period.periodStartDate)
      .join(",");
    dispatch(fetchProcessSteps(periodStartDates));
  }, [currentYear, setPeriods, dispatch]);

  useEffect(() => {
    if (periods.length === 0) {
      return;
    }

    const allPeriodCompensations = periods.map(period => {
      // get compensations based on mode
      if (filteredCompensationsMap) {
        return filteredCompensationsMap.get(period.key) || [];
      }
      return compensationsMap.get(period.key);
    });

    setPeriodCompensations(allPeriodCompensations);
  }, [
    filteredCompensationsMap,
    compensationsMap,
    periods,
    setPeriodCompensations,
  ]);

  useEffect(() => {
    dispatch(getInServiceProfitCenters());
  }, [dispatch]);

  return (
    <Paper className={classes.root}>
      <Header showButton={false} />
      <CompensationTitle />
      <CompensationSearchControls
        currentYear={currentYear}
        setCurrentYear={setCurrentYear}
        periods={periods}
        filteredCompensationsMap={filteredCompensationsMap}
        filteredCompensationCount={filteredCompensationCount}
        searching={searching}
        searchError={searchError}
        searchFieldWidth="500px"
      />
      {periods.map((period, index) => (
        <OriolaPeriodRow
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          preload={index < 6}
          period={period}
          compensations={periodCompensations[index]}
          fetchError={fetchError}
          fetching={fetchingMap.get(period.key) != null}
          inServiceProfitCenters={inServiceProfitCenters}
        />
      ))}
    </Paper>
  );
}

export default Oriola;
